import { render, staticRenderFns } from "./DashboardModalBase.vue?vue&type=template&id=55baa84b&scoped=true&"
import script from "./DashboardModalBase.vue?vue&type=script&lang=ts&"
export * from "./DashboardModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardModalBase.vue?vue&type=style&index=0&id=55baa84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55baa84b",
  null
  
)

export default component.exports